<!-- Overlay -->
<div
  *ngIf="isOpen"
  class="fixed inset-0 z-40 bg-black/40 backdrop-blur-[2px]"
  (click)="onOverlayClick()"
></div>

<!-- Drawer -->
<aside
  class="fixed inset-y-0 left-0 z-50 w-full bg-neutral-gray-100 shadow-xl transition-transform duration-300 ease-out flex flex-col overflow-y-auto"
  [class.-translate-x-full]="!isOpen"
  [class.translate-x-0]="isOpen"
  role="dialog"
  aria-modal="true"
  aria-label="Menú de navegación"
>
  <!-- Header y perfil sticky juntos -->
  <div class="sticky top-0 z-10">
    <!-- Header con logo y botón cerrar -->
    <div class="bg-white px-6 pt-6 pb-3 border-b border-neutral-gray-300">
      <div class="flex items-center justify-between">
        <!-- Logo CANTERA -->
        <button (click)="goToHome()" class="flex items-center hover:opacity-80 transition-opacity">
          <img src="assets/icons/new-logo-header.svg" alt="CANTERA" class="h-10" />
        </button>
        <!-- Botón cerrar -->
        <button
          (click)="onCloseClick('cerrar')"
          aria-label="Cerrar menú"
          class="flex items-center justify-center w-10 h-10 rounded-lg bg-neutral-gray-300 hover:bg-neutral-gray-400 transition-colors"
        >
          <app-svg-icon [iconName]="SvgIcon.SIDE_MENU_CLOSE" [size]="24"></app-svg-icon>
        </button>
      </div>
    </div>

    <!-- Sección de perfil con avatar -->
    <div class="px-6 pt-6 pb-6 relative h-[93px] bg-neutral-gray-200">
      <!-- Imagen de fondo decorativa -->
      <div class="absolute top-0 right-0">
        <img src="assets/img/section-name.png" alt="" class="h-[93px] w-auto object-contain">
      </div>

      <div class="flex items-center gap-3 relative z-10">
        <!-- Avatar circular -->
        <div class="flex-shrink-0">
          <app-svg-icon [iconName]="SvgIcon.SIDE_MENU_AVATAR" [size]="40"></app-svg-icon>
        </div>
        <!-- Nombre del usuario -->
        <div class="flex flex-col text-neutral-gray-900">
          <p class="text-[14px] font-poppins font-normal leading-tight m-0">
            Maestro de Obra
          </p>
          <p class="text-[18px] font-poppins font-semibold leading-tight m-0">
            {{ userName }}
          </p>
        </div>
      </div>
    </div>
  </div>

  <!-- Menú principal -->
  <nav class="px-6 pt-6 pb-6">
    <ul class="flex flex-col gap-4">
      <!-- Inicio -->
      <li>
        <a
          [routerLink]="['/inicio']"
          (click)="onCloseClick('inicio')"
          class="flex items-center gap-3 text-neutral-gray-900 hover:opacity-70 transition-opacity group"
        >
          <img
            src="assets/icons/home.svg"
            alt="Inicio"
            class="w-6 h-6 flex-shrink-0"
          />
          <span class="flex-1 text-[16px] font-poppins font-medium"
            >Inicio</span
          >
          <app-svg-icon [iconName]="SvgIcon.SIDE_MENU_CHEVRON" [size]="24" class="flex-shrink-0 text-neutral-gray-900"></app-svg-icon>
        </a>
        <div class="h-px bg-neutral-gray-200 mt-4"></div>
      </li>

      <!-- Mi perfil -->
      <li>
        <a
          [routerLink]="['/profile']"
          (click)="onCloseClick('profile')"
          class="flex items-center gap-3 text-neutral-gray-900 hover:opacity-70 transition-opacity group"
        >
          <app-svg-icon [iconName]="SvgIcon.USER" [size]="24" class="flex-shrink-0"></app-svg-icon>
          <span class="flex-1 text-[16px] font-poppins font-medium"
            >Mi perfil</span
          >
          <app-svg-icon [iconName]="SvgIcon.SIDE_MENU_CHEVRON" [size]="24" class="flex-shrink-0 text-neutral-gray-900"></app-svg-icon>
        </a>
        <div class="h-px bg-neutral-gray-200 mt-4"></div>
      </li>

      <!-- Mis Cotizaciones -->
      <li>
        <div
          class="flex items-center gap-3 text-neutral-gray-900 hover:opacity-70 transition-opacity group"
        >
          <img
            src="assets/icons/quotes.svg"
            alt="Cotizaciones"
            class="w-6 h-6 flex-shrink-0"
          />
          <span class="flex-1 text-[16px] font-poppins font-medium"
            >Mis Cotizaciones</span
          >
          <app-svg-icon [iconName]="SvgIcon.SIDE_MENU_CHEVRON" [size]="24" class="flex-shrink-0 text-neutral-gray-900"></app-svg-icon>
        </div>
        <div class="h-px bg-neutral-gray-200 mt-4"></div>
      </li>

      <!-- Mis Contratos -->
      <li>
        <div
          class="flex items-center gap-3 text-neutral-gray-900 hover:opacity-70 transition-opacity group"
        >
          <img
            src="assets/icons/contracts.png"
            alt="Contratos"
            class="w-6 h-6 flex-shrink-0"
          />
          <span class="flex-1 text-[16px] font-poppins font-medium"
            >Mis Contratos</span
          >
          <app-svg-icon [iconName]="SvgIcon.SIDE_MENU_CHEVRON" [size]="24" class="flex-shrink-0 text-neutral-gray-900"></app-svg-icon>
        </div>
        <div class="h-px bg-neutral-gray-200 mt-4"></div>
      </li>

      <!-- Mis Capacitaciones -->
      <li>
        <button
          type="button"
          (click)="onCloseClick('training')"
          class="flex items-center gap-3 text-neutral-gray-900 hover:opacity-70 transition-opacity group w-full text-left"
        >
          <img
            src="assets/icons/multimedia.png"
            alt="Capacitaciones"
            class="w-6 h-6 flex-shrink-0"
          />
          <span class="flex-1 text-[16px] font-poppins font-medium"
            >Mis Capacitaciones</span
          >
          <app-svg-icon [iconName]="SvgIcon.SIDE_MENU_CHEVRON" [size]="24" class="flex-shrink-0 text-neutral-gray-900"></app-svg-icon>
        </button>
        <div class="h-px bg-neutral-gray-200 mt-4"></div>
      </li>
    </ul>
  </nav>

  <!-- Sección "¿Qué vas hacer hoy?" -->
  <div class="bg-neutral-gray-900 px-6 py-10">
    <!-- Título -->
    <div class="text-center mb-6">
      <h3 class="text-white text-[20px] font-poppins font-semibold m-0">
        ¿Qué vas hacer hoy?
      </h3>
    </div>

    <!-- Opciones rápidas -->
    <div class="flex flex-col gap-2">
      <!-- Quick action buttons -->
      <ds-side-menu-button 
        *ngFor="let button of quickActionButtons; let i = index"
        [data]="button"
        (click)="onQuickActionClick(i)"
      ></ds-side-menu-button>
    </div>

    <!-- Cerrar sesión -->
    <div class="mt-10 pt-6">
      <button
        (click)="logout()"
        class="flex items-center gap-2 text-neutral-gray-300 hover:text-white transition-colors"
      >
        <app-svg-icon [iconName]="SvgIcon.SIDE_MENU_LOGOUT" [size]="20" class="flex-shrink-0"></app-svg-icon>
        <span class="text-[14px] font-poppins font-semibold"
          >Cerrar sesión</span
        >
      </button>
    </div>
  </div>
</aside>

<app-building-modal
  [showConstructionModal]="showBuildingModal"
  [description]="'Esta herramienta estará disponible próximamente.'"
  [descriptionSecondary]="'Vuelve pronto para probarla'"
  (closeModal)="closeConstructionModal()"
></app-building-modal>

<app-building-modal
  [showConstructionModal]="showTrainingConstructionModal"
  [description]="'Esta sección estará disponible próximamente.'"
  [descriptionSecondary]="'Vuelve pronto para probarla'"
  (closeModal)="closeTrainingConstructionModal()"
></app-building-modal>
